
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class IndexModule extends FetchFactory<IUser> {
  private RESOURCE = '/';

  async getMe(
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IUser>>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}me`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default IndexModule;

